import { useAppSelector } from "../../../../../../store/hooks";
import { isTaskManagementDrawerEditModeSelector } from "../../../../../../store/task-management/selectors/form/options/isTaskManagementDrawerEditModeSelector";
import { usePanelHorizontalResize } from "../../../../../utils/hooks/usePanelHorizontalResize";

export const useTasksPanelHorizontalResizeHook = () => {
  const editMode = useAppSelector(isTaskManagementDrawerEditModeSelector);

  const { width: createWidth, handleMouseDown: createMouseDownHandler } =
    usePanelHorizontalResize(resizingCreateDefaultParams);
  const { width: editWidth, handleMouseDown: editMouseDownHandler } =
    usePanelHorizontalResize(resizingEditDefaultParams);

  return {
    width: editMode ? editWidth : createWidth,
    handleMouseDown: editMode ? editMouseDownHandler : createMouseDownHandler,
  };
};

const resizingCreateDefaultParams = {
  maxWidthPercent: 65,
  defaultWidthPercent: 50,
  minWidthPercent: 30,
  key: "taskCreationDrawerWidth",
};
const resizingEditDefaultParams = {
  maxWidthPercent: 90,
  defaultWidthPercent: 65,
  minWidthPercent: 45,
  key: "taskEditDrawerWidth",
};
